<template>
  <div class="l-page l-page--main">
    <!-- 统计信息行：复用 dev-c-app__header 的 grid 布局，与原首页高度保持一致 -->
    <div class="dev-c-app__header">
      <!-- 设备总数：有设备台账权限才可点击跳转；无权限时悬浮提示 -->
      <el-tooltip
        class="gnmk-stat-card-tooltip"
        content="暂无对应菜单权限，无法跳转"
        placement="top"
        :disabled="hasPermission('/gnmk/device/list')"
      >
        <div
          class="gnmk-stat-card gnmk-stat-card--device"
          :class="{ 'is-locked': !hasPermission('/gnmk/device/list') }"
          @click="hasPermission('/gnmk/device/list') && goToEntry('/gnmk/device/list')"
        >
          <div class="gnmk-stat-card__icon-wrap">
            <i class="el-icon-cpu gnmk-stat-card__icon" />
          </div>
          <div class="gnmk-stat-card__info">
            <div class="gnmk-stat-card__value">{{ stats.deviceTotal }}</div>
            <div class="gnmk-stat-card__label">设备总数</div>
          </div>
        </div>
      </el-tooltip>
      <!-- 故障设备：同设备台账权限 -->
      <el-tooltip
        class="gnmk-stat-card-tooltip"
        content="暂无对应菜单权限，无法跳转"
        placement="top"
        :disabled="hasPermission('/gnmk/device/list')"
      >
        <div
          class="gnmk-stat-card gnmk-stat-card--fault"
          :class="{ 'is-locked': !hasPermission('/gnmk/device/list') }"
          @click="hasPermission('/gnmk/device/list') && goToEntry('/gnmk/device/list')"
        >
          <div class="gnmk-stat-card__icon-wrap">
            <i class="el-icon-warning-outline gnmk-stat-card__icon" />
          </div>
          <div class="gnmk-stat-card__info">
            <div class="gnmk-stat-card__value">{{ stats.deviceFault }}</div>
            <div class="gnmk-stat-card__label">故障设备</div>
          </div>
        </div>
      </el-tooltip>
      <!-- 故障单：有故障台账权限才可点击跳转 -->
      <el-tooltip
        class="gnmk-stat-card-tooltip"
        content="暂无对应菜单权限，无法跳转"
        placement="top"
        :disabled="hasPermission('/gnmk/fault/list')"
      >
        <div
          class="gnmk-stat-card gnmk-stat-card--ticket"
          :class="{ 'is-locked': !hasPermission('/gnmk/fault/list') }"
          @click="hasPermission('/gnmk/fault/list') && goToEntry('/gnmk/fault/list')"
        >
          <div class="gnmk-stat-card__icon-wrap">
            <i class="el-icon-document gnmk-stat-card__icon" />
          </div>
          <div class="gnmk-stat-card__info">
            <div class="gnmk-stat-card__value">{{ stats.faultPendingTotal }}</div>
            <div class="gnmk-stat-card__label">待处理故障单</div>
          </div>
        </div>
      </el-tooltip>
      <!-- 待执行任务：有任务管理权限才可点击跳转 -->
      <el-tooltip
        class="gnmk-stat-card-tooltip"
        content="暂无对应菜单权限，无法跳转"
        placement="top"
        :disabled="hasPermission('/gnmk/task')"
      >
        <div
          class="gnmk-stat-card gnmk-stat-card--task"
          :class="{ 'is-locked': !hasPermission('/gnmk/task') }"
          @click="hasPermission('/gnmk/task') && goToEntry('/gnmk/task')"
        >
          <div class="gnmk-stat-card__icon-wrap">
            <i class="el-icon-date gnmk-stat-card__icon" />
          </div>
          <div class="gnmk-stat-card__info">
            <div class="gnmk-stat-card__value">{{ stats.pendingTaskTotal }}</div>
            <div class="gnmk-stat-card__label">待执行任务</div>
          </div>
        </div>
      </el-tooltip>
    </div>

    <!-- 页面主内容 -->
    <div class="dev-c-app__content">
      <!-- 左：快捷入口（根据用户菜单权限动态过滤） -->
      <div class="dev-c-app__panel dev-c-app__panel--left">
        <div class="dev-c-app__panel-header">
          <div class="dev-c-app__panel-title">快捷入口</div>
        </div>
        <div class="dev-c-app__panel-body">
          <div class="dev-o-enter">
            <div
              v-for="(item, index) in visibleEntries"
              :key="index"
              class="dev-o-enter__item"
              @click="goToEntry(item.path)"
            >
              <div class="dev-o-enter__icon" :style="{ backgroundColor: item.bgColor }">
                <i :class="['el-icon-' + item.icon, 'gnmk-entry-icon']" :style="{ color: item.iconColor }"/>
              </div>
              <div class="dev-o-enter__text">{{ item.text }}</div>
            </div>
          </div>
          <div v-if="visibleEntries.length === 0" class="dev-c-app__panel-empty">
            <i class="el-icon-lock" style="font-size: 36px;"/>
            <span>暂无可用入口</span>
          </div>
        </div>
      </div>

      <!-- 右：两个独立卡片——未完成任务、未处理故障 -->
      <div class="dev-c-app__panel dev-c-app__panel--right gnmk-home-right-wrap">
        <div class="gnmk-home-split">
          <div class="gnmk-home-split__section gnmk-home-card">
            <div class="dev-c-app__panel-header">
              <div class="dev-c-app__panel-title">未完成任务</div>
              <span
                class="dev-c-app__panel-more"
                :style="hasPermission('/gnmk/task') ? {} : { cursor: 'default', opacity: 0.4 }"
                @click="hasPermission('/gnmk/task') && goToEntry('/gnmk/task')"
              >查看全部 &gt;</span>
            </div>
            <div class="dev-c-app__panel-body gnmk-home-split__body">
              <div v-if="recentTaskList.length > 0">
                <div
                  v-for="item in recentTaskList"
                  :key="item.uuid"
                  class="gnmk-task-item"
                  @click="hasPermission('/gnmk/task') && goToEntry('/gnmk/task')"
                >
                  <div class="gnmk-task-item__dot" :class="item.status === 1 ? 'is-ongoing' : ''"/>
                  <div class="gnmk-task-item__name" :title="item.taskName">{{ item.taskName }}</div>
                  <div class="gnmk-task-item__tag">
                    <el-tag size="mini" :type="getStatusTag(item.status)">
                      {{ item.statusName != null && item.statusName !== '' ? item.statusName : item.status }}
                    </el-tag>
                  </div>
                  <div class="gnmk-task-item__period"> {{ item.periodName }}</div>
                </div>
              </div>
              <div v-else-if="!taskLoading" class="dev-c-app__panel-empty gnmk-home-split__empty">
                <i class="el-icon-circle-check" style="font-size: 48px; color: #67c23a;"/>
                <span>暂无未完成任务</span>
              </div>
            </div>
          </div>

          <div class="gnmk-home-split__section gnmk-home-card">
            <div class="dev-c-app__panel-header">
              <div class="dev-c-app__panel-title">未处理故障</div>
              <span
                class="dev-c-app__panel-more"
                :style="hasPermission('/gnmk/fault/list') ? {} : { cursor: 'default', opacity: 0.4 }"
                @click="hasPermission('/gnmk/fault/list') && goToEntry('/gnmk/fault/list')"
              >查看全部 &gt;</span>
            </div>
            <div class="dev-c-app__panel-body gnmk-home-split__body">
              <div v-if="recentFaultList.length > 0">
                <div
                  v-for="item in recentFaultList"
                  :key="item.uuid"
                  class="gnmk-fault-item"
                  @click="hasPermission('/gnmk/fault/list') && goToEntry('/gnmk/fault/list')"
                >
                  <div class="gnmk-fault-item__dot" :class="item.faultLevel === 'urgent' ? 'is-urgent' : ''"/>
                  <div class="gnmk-fault-item__main">
                    <div class="gnmk-fault-item__title" :title="item.faultCode + ' ' + (item.deviceName || '')">
                      <span class="gnmk-fault-item__code">{{ item.faultCode }}</span>
                      <span class="gnmk-fault-item__device">{{ item.deviceName || '-' }}</span>
                    </div>
                  </div>
                  <div class="gnmk-fault-item__tag">
                    <el-tag size="mini" :type="getFaultStatusTagType(item.status)">
                      {{ item.statusName || item.status }}
                    </el-tag>
                  </div>
                </div>
              </div>
              <div v-else-if="!faultLoading" class="dev-c-app__panel-empty gnmk-home-split__empty">
                <i class="el-icon-circle-check" style="font-size: 48px; color: #67c23a;"/>
                <span>暂无未处理故障</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HMCoreStoreService } from 'kestrel-core-ui';
import { taskService } from '@/features/gnmk/task/task.service';
import { deviceService } from '@/features/gnmk/device/device.service';
import { faultService } from '@/features/gnmk/fault/fault.service';

export default {
  name: 'GnmkHome',
  data () {
    return {
      // 顶部统计数据
      stats: {
        deviceTotal: 0,
        deviceFault: 0,
        pendingTaskTotal: 0,
        faultPendingTotal: 0
      },
      taskLoading: false,
      recentTaskList: [],
      faultLoading: false,
      /** 首页展示的未处理故障（pending / reported），与顶部「待处理故障单」数量同源 */
      recentFaultList: [],
      // 过滤后的可见快捷入口
      visibleEntries: [],
      // 用户可访问的菜单路径列表（用于权限判断，在 filterEntries 中赋值）
      accessiblePaths: [],
      // 全量快捷入口配置（路径需与菜单 menuUrl 精确匹配，用于权限过滤）
      // bgColor / iconColor：按模块语义区分——区域(版图绿)、人员(青)、内容库(绿)、任务(日程琥珀)、设备(蓝)、故障(警示红)、工具(靛紫)、材料(仓储棕)
      gnmkEntries: [
        { text: '区域管理', icon: 'location', bgColor: '#e8f8f0', iconColor: '#36b37e', path: '/gnmk/area/list' },
        { text: '人员小组管理', icon: 'user', bgColor: '#defdff', iconColor: '#10d0de', path: '/gnmk/team/list' },
        { text: '任务内容库', icon: 'tickets', bgColor: '#f0f9eb', iconColor: '#67c23a', path: '/gnmk/checkContent' },
        { text: '任务管理', icon: 'date', bgColor: '#fdf6ec', iconColor: '#e6a23c', path: '/gnmk/task' },
        { text: '设备台账', icon: 'cpu', bgColor: '#ecf5ff', iconColor: '#409eff', path: '/gnmk/device/list' },
        { text: '故障台账', icon: 'warning-outline', bgColor: '#fef0f0', iconColor: '#f56c6c', path: '/gnmk/fault/list' },
        { text: '工具台账', icon: 's-tools', bgColor: '#f3f0ff', iconColor: '#7c6bcf', path: '/gnmk/tool/list' },
        { text: '材料台账', icon: 'goods', bgColor: '#faf6f0', iconColor: '#c48f65', path: '/gnmk/material/list' }
      ]
    };
  },
  methods: {
    /**
     * 跳转到对应功能模块
     * @param {string} path 路由路径
     */
    goToEntry (path) {
      this.openNavTab({ path });
    },

    /**
     * 检查指定路径是否在用户的菜单权限内
     * @param {string} path 路由路径
     * @returns {boolean}
     */
    hasPermission (path) {
      return this.accessiblePaths.includes(path);
    },

    /**
     * 根据用户菜单权限过滤快捷入口，并记录可访问路径列表
     * appMenusLeaf 存储了用户有权访问的所有叶子菜单节点（含 menuUrl）
     */
    filterEntries () {
      const menuLeaf = HMCoreStoreService.getMenuState('appMenusLeaf') || [];
      this.accessiblePaths = menuLeaf.map(m => m.menuUrl);
      this.visibleEntries = this.gnmkEntries.filter(entry => this.accessiblePaths.includes(entry.path));
    },

    /**
     * 加载设备统计（设备总数、故障设备数）
     */
    loadDeviceStats () {
      deviceService.getDeviceStatistics().then(res => {
        if (res.data) {
          this.stats.deviceTotal = res.data.total || 0;
          this.stats.deviceFault = res.data.fault || 0;
        }
      }).catch(() => {});
    },

    /**
     * 未处理故障分页查询：与业务定义一致（待处理 + 已上报待处理，不含已维修）
     * 同时写入顶部「待处理故障单」数量与右下列表
     */
    loadPendingFaultPage () {
      this.faultLoading = true;
      faultService.queryFaultPage({ statusList: ['pending', 'reported'], pageNo: 1, pageSize: 6 })
        .then(rsp => {
          const data = rsp.data || {};
          this.recentFaultList = data.list || data.rows || [];
          this.stats.faultPendingTotal = data.total != null ? data.total : 0;
        })
        .catch(err => {
          console.error('获取未处理故障失败', err);
        })
        .finally(() => {
          this.faultLoading = false;
        });
    },

    /**
     * 加载未完成任务列表，同时更新顶部统计数
     */
    loadRecentTasks () {
      this.taskLoading = true;
      taskService.queryTaskPage({ statusList: [0, 1], pageNo: 1, pageSize: 6 })
        .then(rsp => {
          const data = rsp.data;
          this.recentTaskList = data.list || data.rows || [];
          this.stats.pendingTaskTotal = data.total || 0;
        })
        .catch(err => {
          console.error('获取未完成任务失败', err);
        })
        .finally(() => {
          this.taskLoading = false;
        });
    },

    getStatusTag (status) {
      return { 0: 'info', 1: '' }[status] ?? '';
    },

    getFaultStatusTagType (status) {
      return { pending: 'warning', reported: 'primary', fixed: 'success' }[status] || '';
    }
  },
  created () {
    this.filterEntries();
    this.loadDeviceStats();
    this.loadRecentTasks();
    this.loadPendingFaultPage();
  },
  activated () {
    this.loadDeviceStats();
    this.loadRecentTasks();
    this.loadPendingFaultPage();
  }
};
</script>

<style lang="scss" scoped>
@import "../../main/main.scss";

// panel-body 改为 flex 列布局，使空状态能正确占满剩余高度
// 原 main.scss 中 height:90% + overflow:auto 会导致子元素 height:100% 计算失效
.dev-c-app__panel-body {
  display: flex;
  flex-direction: column;
}

.dev-c-app__panel-empty {
  flex: 1;
  height: auto;
  min-height: 150px;
}

/* el-tooltip 根节点默认偏行内，作为 grid 子项时需占满单元格，避免四列布局挤压 */
.gnmk-stat-card-tooltip {
  display: block;
  min-width: 0;
}

/* 统计卡片 - 复用 dev-o-app 的视觉风格，以 el-icon 替代图片 */
.gnmk-stat-card {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(164, 164, 164, 0.16);
  cursor: pointer;

  &__icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.25);
    flex-shrink: 0;
  }

  &__icon {
    font-size: 32px;
    color: #fff;
  }

  &__info {
    margin-left: 20px;
    color: #fff;
  }

  &__value {
    font-size: 36px;
    line-height: 46px;
    font-weight: 600;
  }

  &__label {
    margin-top: 4px;
    font-size: 14px;
    opacity: 0.9;
  }

  /* 无权限：禁用指针，轻微置灰 */
  &.is-locked {
    cursor: not-allowed;
    opacity: 0.65;
  }

  /* 设备总数：蓝色 */
  &--device {
    background-image: linear-gradient(272deg, #8eceff 0%, #67b6ff 100%);
  }

  /* 故障设备：红色 */
  &--fault {
    background-image: linear-gradient(272deg, #fea0a0 0%, #ff8181 59%, #ff6d6d 100%);
  }

  /* 待执行任务：青色 */
  &--task {
    background-image: linear-gradient(269deg, #7ef1ff 0%, #10d0de 100%);
  }

  /* 故障单：橙色，可点击跳转 */
  &--ticket {
    background-image: linear-gradient(271deg, #ffdcb1 0%, #ffa641 100%);
  }
}

/* 快捷入口：图标尺寸与悬停反馈（配色由 gnmkEntries 各模块 bgColor/iconColor 控制） */
.dev-o-enter__icon {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.dev-o-enter__item {
  cursor: pointer;

  &:hover .dev-o-enter__icon {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }
}

.gnmk-entry-icon {
  font-size: 36px;
}

/* 未完成任务列表项 */
.gnmk-task-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  color: #737375;

  &:hover {
    color: #3ba6ff;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #909399; // 待执行：灰色
    flex-shrink: 0;

    &.is-ongoing {
      background-color: #e6a23c; // 进行中：橙色
    }
  }

  &__name {
    flex: 1;
    margin-left: 12px;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__tag {
    margin: 0 12px;
  }

  &__period {
    font-size: 13px;
    color: #999;
    flex-shrink: 0;
  }
}

/* 右侧外层：不再用一整块白底，避免两区块视觉上「糊成一张」 */
.gnmk-home-right-wrap {
  background: transparent !important;
  box-shadow: none !important;
}

/* 右侧栏上下分块：卡片之间留白，各占约一半高度 */
.gnmk-home-split {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  gap: 14px;
}

/* 单块卡片：与左侧快捷入口面板同风格的独立白卡片 */
.gnmk-home-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 3px 3px 0 hsl(0deg 0% 82% / 16%);
}

.gnmk-home-split__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 0 !important;
}

.gnmk-home-split__empty {
  min-height: 150px;
}

/* 未处理故障行（与任务行视觉对齐） */
.gnmk-fault-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  color: #737375;

  &:hover {
    color: #3ba6ff;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #e6a23c;
    flex-shrink: 0;

    &.is-urgent {
      background-color: #f56c6c;
    }
  }

  &__main {
    flex: 1;
    margin-left: 12px;
    min-width: 0;
  }

  &__title {
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__code {
    font-weight: 600;
    margin-right: 8px;
  }

  &__device {
    color: #606266;
  }

  &__tag {
    flex-shrink: 0;
    margin-left: 8px;
  }
}
</style>
